// MakingofaRobot
import React from 'react';
import MariaMontessoriDay2024  from 'views/MariaMontessoriDay2024';

const LogisticsPage = () => {
  return <MariaMontessoriDay2024 />;
};

export default LogisticsPage;
